import React from "react";
import { CoBrowseContext } from "../../../store/coBrowse.context";
import NavigationOffer from "../../organisms/coBrowsing/navigationOffer/navigationOffer";
import ICoBrowseDto from "../../../interface/ICoBrowseDto";
import CoBrowsingNavBar from "../../atoms/coBrowsingOffer.styled";
import ControlOffer from "../../organisms/coBrowsing/controlOffer/controlOffer";
import CoBrowseOffer from "../../organisms/coBrowsing/coBrowseOffer/coBrowseOffer";
import CoBrowseButtons from "../../organisms/coBrowsing/coBrowseButtons/coBrowseButtons";
import CoBrowseStatus from "../../organisms/coBrowsing/coBrowseStatus/coBrowseStatus";
import Grid from "@mui/material/Grid2";

const RenderCoBrowsing = (): React.JSX.Element => {
  const {
    coBrowseDto,
  }: {
    coBrowseDto: ICoBrowseDto;
  } = React.useContext(CoBrowseContext);

  return (
    <CoBrowsingNavBar>
      <Grid
        container
        spacing={2}
        sx={{
          width: "100%",
        }}
      >
        <CoBrowseStatus />

        {coBrowseDto.session.type === "Offering" && <CoBrowseOffer />}

        {coBrowseDto.session.sessionId !== "" &&
          coBrowseDto.session.type !== "Offering" && <CoBrowseButtons />}
      </Grid>

      {coBrowseDto.control.offer && <ControlOffer />}
      {coBrowseDto.navigation.offer && <NavigationOffer />}
    </CoBrowsingNavBar>
  );
};

export default RenderCoBrowsing;
